import { render, staticRenderFns } from "./TrademarkObjectionToUsStatusList.vue?vue&type=template&id=24246c57&"
import script from "./TrademarkObjectionToUsStatusList.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsStatusList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkObjectionToUsStatusList.vue?vue&type=style&index=0&id=24246c57&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports